import { render, staticRenderFns } from "./haiHeQuestionnaireDetail.vue?vue&type=template&id=522f7a63&scoped=true"
import script from "./haiHeQuestionnaireDetail.vue?vue&type=script&lang=js"
export * from "./haiHeQuestionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./haiHeQuestionnaireDetail.vue?vue&type=style&index=0&id=522f7a63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f7a63",
  null
  
)

export default component.exports